import { cn } from "../../utils/helpers";
const Card = ({ children, className, ...rest }) => {
  return (
    <div
      className={cn("card border border-1 pattern-card", className)}
      {...rest}
    >
      <div className="card-body">{children}</div>
    </div>
  );
};

export default Card;

export const CardItem = ({ children }) => {
  return (
    <div className="card mb-2 shadow-sm">
      <div className="card-body p-4">
        <div className="row g-3 align-items-center">{children}</div>
      </div>
    </div>
  );
};

CardItem.Header = ({ children }) => {
  return <div className="col-12 border-bottom pb-1">{children}</div>;
};
CardItem.Footer = ({ children }) => {
  return <div className="col-12 border-top pt-1">{children}</div>;
};
